// extracted by mini-css-extract-plugin
export default {"path":"CloseIcon_path__9V89j"};